import React from "react";

import { ReactComponent as IconStudent } from "../../../assets/svg/student-comment.svg";
import { IAnswer } from "../../../state";
import { generateFullName, keyGenerator } from "../../../libs/Util";
import OneAnswerBox from "../OneAnswerBox";

import styles from "./AnswerBox.module.scss";

export type AnswerBoxProps = {
  calling: boolean;
  studentAnswers: IAnswer[];
  currentTeacherID: number;
  name_opend: boolean;
  classFullName?: string;
  isGroupAnswer?: boolean;
  isShowClassFullName?: boolean;
  handleComment: (
    content: string,
    answer_id: number,
    comment_id?: number,
  ) => void;
  handleToggleComment: (
    answer_id: number,
    comment_id: number,
    is_hidden: boolean,
  ) => void;
  handleDeleteComment: (answer_id: number, comment_id: number) => void;
};

const AnswerBox = React.forwardRef<HTMLDivElement, AnswerBoxProps>(
  (
    {
      calling,
      studentAnswers,
      currentTeacherID,
      name_opend,
      classFullName,
      isGroupAnswer = false,
      isShowClassFullName,
      handleComment,
      handleToggleComment,
      handleDeleteComment,
    },
    ref,
  ) => {
    const className = isShowClassFullName ? `${classFullName} ` : "";

    return (
      <div
        className={styles.answer}
        key={keyGenerator(studentAnswers)}
        ref={ref}
      >
        <h5>
          <IconStudent />
          {name_opend
            ? generateFullName([
                studentAnswers[0].student.last_name,
                studentAnswers[0].student.first_name,
              ])
            : `${className}回答${studentAnswers[0].index}`}
        </h5>
        {studentAnswers.map(answer => (
          <OneAnswerBox
            key={answer.id}
            calling={calling}
            currentTeacherID={currentTeacherID}
            name_opened={name_opend}
            answer={answer}
            isGroupAnswer={isGroupAnswer}
            handleComment={handleComment}
            handleToggleComment={handleToggleComment}
            handleDeleteComment={handleDeleteComment}
          />
        ))}
      </div>
    );
  },
);

export default AnswerBox;
